import React, { useState, useEffect } from "react";
import {
  Typography, Grid, TextField, Switch, FormControlLabel,
  Accordion, AccordionSummary, AccordionDetails,
  FormControl, InputLabel, Select, MenuItem, CircularProgress,
  Divider
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getListe, getCampagne, getGruppi } from "../../utils/mailup";

const STATI_ACQUISITO = ["chiusoAcquisito", "completato", "fatturato", "archiviato"];

export default function SezioneDEM({ form, handleChange }) {
  const [listeMailUp, setListeMailUp] = useState([]);
  const [campagneMailUp, setCampagneMailUp] = useState([]);
  const [gruppiMailUp, setGruppiMailUp] = useState([]);
  const [loadingListe, setLoadingListe] = useState(false);
  const [loadingCampagne, setLoadingCampagne] = useState(false);
  const [loadingGruppi, setLoadingGruppi] = useState(false);

  const mostraMailUp = STATI_ACQUISITO.includes(form.stato);

  // Carica liste MailUp quando la sezione diventa visibile
  useEffect(() => {
    if (!mostraMailUp) return;
    setLoadingListe(true);
    getListe()
      .then(setListeMailUp)
      .finally(() => setLoadingListe(false));
  }, [mostraMailUp]);

  // Carica campagne quando cambia la lista selezionata
  useEffect(() => {
    if (!form.mailupListaId) {
      setCampagneMailUp([]);
      setGruppiMailUp([]);
      return;
    }
    setLoadingCampagne(true);
    setLoadingGruppi(true);
    Promise.all([
      getCampagne(form.mailupListaId),
      getGruppi(form.mailupListaId),
    ]).then(([campagne, gruppi]) => {
      setCampagneMailUp(campagne);
      setGruppiMailUp(gruppi);
    }).finally(() => {
      setLoadingCampagne(false);
      setLoadingGruppi(false);
    });
  }, [form.mailupListaId]);

  return (
    <>
      {/* DEM - SURVEY */}
      <Accordion defaultExpanded elevation={1} sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#FAECE7" }}>
          <Typography fontWeight="bold">DEM - Survey</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <FormControlLabel control={<Switch checked={form.surveyPostEvento}
                onChange={(e) => handleChange("surveyPostEvento", e.target.checked)} />}
                label="Survey post-evento attiva" />
            </Grid>
            {form.surveyPostEvento && (
              <Grid item xs={12} md={6}>
                <TextField fullWidth label="DEM - Survey" type="datetime-local"
                  value={form.demSurvey}
                  onChange={(e) => handleChange("demSurvey", e.target.value)}
                  InputLabelProps={{ shrink: true }} />
              </Grid>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* DEM */}
      <Accordion defaultExpanded elevation={1} sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#EAF3DE" }}>
          <Typography fontWeight="bold">DEM</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <FormControlLabel control={<Switch checked={form.demAttiva}
                onChange={(e) => handleChange("demAttiva", e.target.checked)} />}
                label="DEM attiva" />
            </Grid>
            {form.demAttiva && (
              <>
                <Grid item xs={12} md={6}>
                  <TextField fullWidth label="DEM - Invito" type="datetime-local"
                    value={form.demInvito}
                    onChange={(e) => handleChange("demInvito", e.target.value)}
                    InputLabelProps={{ shrink: true }} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField fullWidth label="DEM - Reminder" type="datetime-local"
                    value={form.demReminder}
                    onChange={(e) => handleChange("demReminder", e.target.value)}
                    InputLabelProps={{ shrink: true }} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField fullWidth label="DEM - Promemoria" type="datetime-local"
                    value={form.demPromemoria}
                    onChange={(e) => handleChange("demPromemoria", e.target.value)}
                    InputLabelProps={{ shrink: true }} />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Lista destinatari" value={form.listaDestinatari}
                    onChange={(e) => handleChange("listaDestinatari", e.target.value)} />
                </Grid>
              </>
            )}

            {/* CAMPI MAILUP — visibili solo da chiusoAcquisito in poi */}
            {mostraMailUp && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="subtitle2" fontWeight="bold" color="text.secondary"
                    sx={{ mt: 1, mb: 1, textTransform: "uppercase", letterSpacing: 1, fontSize: 11 }}>
                    Collegamento MailUp
                  </Typography>
                </Grid>

                {/* Lista MailUp */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Lista MailUp</InputLabel>
                    <Select
                      value={form.mailupListaId || ""}
                      label="Lista MailUp"
                      onChange={(e) => {
                        handleChange("mailupListaId", e.target.value);
                        handleChange("mailupInvitoId", "");
                        handleChange("mailupReminderId", "");
                        handleChange("mailupPromemoriaId", "");
                        handleChange("mailupGruppoTuttiId", "");
                        handleChange("mailupGruppoConfermaId", "");
                        handleChange("mailupGruppoNoId", "");
                      }}
                      disabled={loadingListe}
                    >
                      <MenuItem value="">— Nessuna —</MenuItem>
                      {listeMailUp.map((l) => (
                        <MenuItem key={l.IdList} value={l.IdList}>{l.Name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {form.mailupListaId && (
                  <>
                    {/* Messaggi */}
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel>Messaggio INVITO</InputLabel>
                        <Select
                          value={form.mailupInvitoId || ""}
                          label="Messaggio INVITO"
                          onChange={(e) => handleChange("mailupInvitoId", e.target.value)}
                          disabled={loadingCampagne}
                        >
                          <MenuItem value="">— Nessuno —</MenuItem>
                          {campagneMailUp.map((c) => (
                            <MenuItem key={c.idMessage} value={c.idMessage}>
                              {c.Notes || c.Subject}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel>Messaggio REMINDER</InputLabel>
                        <Select
                          value={form.mailupReminderId || ""}
                          label="Messaggio REMINDER"
                          onChange={(e) => handleChange("mailupReminderId", e.target.value)}
                          disabled={loadingCampagne}
                        >
                          <MenuItem value="">— Nessuno —</MenuItem>
                          {campagneMailUp.map((c) => (
                            <MenuItem key={c.idMessage} value={c.idMessage}>
                              {c.Notes || c.Subject}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel>Messaggio PROMEMORIA</InputLabel>
                        <Select
                          value={form.mailupPromemoriaId || ""}
                          label="Messaggio PROMEMORIA"
                          onChange={(e) => handleChange("mailupPromemoriaId", e.target.value)}
                          disabled={loadingCampagne}
                        >
                          <MenuItem value="">— Nessuno —</MenuItem>
                          {campagneMailUp.map((c) => (
                            <MenuItem key={c.idMessage} value={c.idMessage}>
                              {c.Notes || c.Subject}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Gruppi */}
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel>Gruppo TUTTI</InputLabel>
                        <Select
                          value={form.mailupGruppoTuttiId || ""}
                          label="Gruppo TUTTI"
                          onChange={(e) => handleChange("mailupGruppoTuttiId", e.target.value)}
                          disabled={loadingGruppi}
                        >
                          <MenuItem value="">— Nessuno —</MenuItem>
                          {gruppiMailUp.map((g) => (
                            <MenuItem key={g.idGroup} value={g.idGroup}>{g.Name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel>Gruppo CONFERMATI</InputLabel>
                        <Select
                          value={form.mailupGruppoConfermaId || ""}
                          label="Gruppo CONFERMATI"
                          onChange={(e) => handleChange("mailupGruppoConfermaId", e.target.value)}
                          disabled={loadingGruppi}
                        >
                          <MenuItem value="">— Nessuno —</MenuItem>
                          {gruppiMailUp.map((g) => (
                            <MenuItem key={g.idGroup} value={g.idGroup}>{g.Name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel>Gruppo NON CONFERMATI</InputLabel>
                        <Select
                          value={form.mailupGruppoNoId || ""}
                          label="Gruppo NON CONFERMATI"
                          onChange={(e) => handleChange("mailupGruppoNoId", e.target.value)}
                          disabled={loadingGruppi}
                        >
                          <MenuItem value="">— Nessuno —</MenuItem>
                          {gruppiMailUp.map((g) => (
                            <MenuItem key={g.idGroup} value={g.idGroup}>{g.Name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  );
}